import { render } from "./ContactConfirm.vue?vue&type=template&id=5de1ee6c"
import script from "./ContactConfirm.vue?vue&type=script&lang=js"
export * from "./ContactConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script